$(document).ready(function ($) {
  "use strict"; 
  function megaMenu() {
    if($('.default_dropdown').length > 0 ) {
    if ($("#header .page-full-width").length) {
      var parentRow = $("#header .page-full-width > .row");
      var parentLeft = parseInt(parentRow.css("marginLeft").replace("px", ""));
    } else {
      var parentRow = $("#header .page-width .row");
      var parentLeft = parseInt(parentRow.offset().left);
    }
    var parentWidth = parentRow.width();

    $("#header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > a").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);
        thisItem.find(".sub-menu-block").css("width", parentWidth);
       }
    });

    $("sticky-header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > a").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);        
        thisItem.find(".sub-menu-block").css("width", parentWidth);      
      }
    });
    window.setTimeout(function () {
      $(window).trigger("resize");
    }, 800);

    }
  }
  var megaMenuResize = false;
  $(window).bind("resize", function () {
    if (!megaMenuResize) {
      megaMenu();
      megaMenuResize = true;
    }
  });
  megaMenu();
});

$(function () {
  if ($(window).width() >= 1200) {
    $(".deskTabs a").click(function () {
      let id = $(this).attr("href");
      $(".deskTabs li").removeClass("active");
      $(this).parent().addClass("active");
      $(this).parent().parent().parent().parent().addClass("active");
      $(".tabs-content li.dt-sc-menu-tabs").hide();
      $(this).parent().parent().parent().parent().find(id).show();

      return false;
    });
  }
  if ($(window).width() <= 1199) {
    $(".mobileTabs .tabs  li").each(function () {
      $(this).click(function () {
        $(this).next("div").slideToggle(0);
      });
    });
  }
});
$(document).ready(function () {
  $("#category-menu-button").click(function () {
    $(this).toggleClass("open");
    $(".category-wrapper").toggleClass("open");
    $(".category-wrapper").slideToggle(0);
  });
});

/* =========================================================
   MOBILE SHOP SUBMENU ACCORDION
   ========================================================= */

$(document).on("click", ".mobile-submenu-toggle", function (e) {
  e.preventDefault();
  e.stopPropagation();

  // Mobile only
  if ($(window).width() > 989) {
    return;
  }

  var $button = $(this);
  var $item = $button.closest(".mobile-accordion-item");
  var isOpen = $item.hasClass("is-open");

  // Close other categories
  $item
    .siblings(".mobile-accordion-item")
    .removeClass("is-open")
    .find(".mobile-submenu-toggle")
    .attr("aria-expanded", "false");

  // Toggle current category
  if (isOpen) {
    $item.removeClass("is-open");
    $button.attr("aria-expanded", "false");
  } else {
    $item.addClass("is-open");
    $button.attr("aria-expanded", "true");
  }
});

/* =========================================================
   MOBILE DRAWER ACCORDION
   ========================================================= */

function initMobileDrawerAccordion() {

  if ($(window).width() > 989) {
    return;
  }

  $(".menu-drawer__menu .sub-menu-block .sub-menu-lists > li.menu-item-has-children").each(function () {

    var $item = $(this);
    var $submenu = $item.children(".sub-menu-block");

    /* Only items that actually have a nested submenu */
    if (!$submenu.length) {
      return;
    }

    /* Prevent duplicate buttons */
    if ($item.children(".mobile-drawer-toggle").length) {
      return;
    }

    var button =
      '<button type="button" class="mobile-drawer-toggle" aria-expanded="false" aria-label="Open submenu">' +
        '<span>+</span>' +
      '</button>';

    $item.children("a").first().after(button);
  });
}


/* Run on page load */
$(document).ready(function () {
  initMobileDrawerAccordion();
});


/* Run again when mobile menu is interacted with */
$(document).on("click", ".menu-drawer, .header__icon--menu", function () {
  setTimeout(function () {
    initMobileDrawerAccordion();
  }, 100);
});


/* Open / close category */
$(document).on("click", ".mobile-drawer-toggle", function (e) {

  e.preventDefault();
  e.stopPropagation();

  if ($(window).width() > 989) {
    return;
  }

  var $button = $(this);
  var $item = $button.parent("li.menu-item-has-children");

  var isOpen = $item.hasClass("mobile-drawer-open");


  /* Close other open categories */
  $item
    .siblings("li.menu-item-has-children")
    .removeClass("mobile-drawer-open")
    .children(".mobile-drawer-toggle")
    .attr("aria-expanded", "false");


  if (isOpen) {

    $item.removeClass("mobile-drawer-open");
    $button.attr("aria-expanded", "false");

  } else {

    $item.addClass("mobile-drawer-open");
    $button.attr("aria-expanded", "true");

  }

});

/* =========================================================
   FINAL SAFE DESKTOP MEGA MENU
   ========================================================= */

$(document).ready(function () {

  var closeTimer = null;

  var $nav = $(
    ".header ul.dt-sc-list-inline.dt-desktop-menu.dt-nav"
  );

  var $items = $nav.children(
    "li.menu-item-has-children"
  );


  function openMenu($item) {

    clearTimeout(closeTimer);

    $items
      .not($item)
      .removeClass("dt-safe-mega-open");

    $item.addClass("dt-safe-mega-open");
  }


  function scheduleClose($item) {

    clearTimeout(closeTimer);

    closeTimer = setTimeout(function () {

      var $link = $item
        .children(".megamenu_megamenu")
        .children("a.dt-sc-nav-link");

      var $submenu = $item
        .children(".megamenu_megamenu")
        .children(".sub-menu-block");

      if (!$link.is(":hover") && !$submenu.is(":hover")) {
        $item.removeClass("dt-safe-mega-open");
      }

    }, 120);
  }


  /* OPEN ONLY WHEN REAL TOP NAV LINK IS HOVERED */
  $nav.on(
    "mouseenter.safeMega",
    "> li.menu-item-has-children > .megamenu_megamenu > a.dt-sc-nav-link",
    function () {

      if ($(window).width() < 990) return;

      openMenu(
        $(this).closest("li.menu-item-has-children")
      );
    }
  );


  /* KEEP CURRENT DROPDOWN OPEN */
  $nav.on(
    "mouseenter.safeMega",
    "> li.menu-item-has-children > .megamenu_megamenu > .sub-menu-block",
    function () {

      if ($(window).width() < 990) return;

      clearTimeout(closeTimer);

      openMenu(
        $(this).closest("li.menu-item-has-children")
      );
    }
  );


  /* LEAVING TOP LINK */
  $nav.on(
    "mouseleave.safeMega",
    "> li.menu-item-has-children > .megamenu_megamenu > a.dt-sc-nav-link",
    function () {

      if ($(window).width() < 990) return;

      scheduleClose(
        $(this).closest("li.menu-item-has-children")
      );
    }
  );


  /* LEAVING DROPDOWN */
  $nav.on(
    "mouseleave.safeMega",
    "> li.menu-item-has-children > .megamenu_megamenu > .sub-menu-block",
    function () {

      if ($(window).width() < 990) return;

      scheduleClose(
        $(this).closest("li.menu-item-has-children")
      );
    }
  );

});